import React, { useCallback, useState } from 'react';
import { Title } from '../../components/title';
import { createCn } from 'bem-react-classname';
import './style.css';
import { useTranslation } from 'react-i18next';
import { Modal } from '../../components/modal';
import { ImagesEn } from './images_en';
import { ImagesIt } from './images_it';

const cn = createCn('workplan');

function setOverflow(flag: boolean) {
    const overflowValue = flag ? 'hidden' : '';
    document.documentElement.style.overflow = overflowValue;
    document.body.style.overflow = overflowValue;
}

export const Workplan = () => {
    const { i18n } = useTranslation();
    const pdfUrl = i18n.language === 'en' ? './pdf/ENG_Workplan.pdf' : './pdf/IT_Workplan.pdf';
    // const pdfUrl = './pdf/IT_Workplan.pdf';

    const [visible, setVisible] = useState(false);
    const [imgId, setImgId] = useState('');
    const images = i18n.language === 'en' ? ImagesEn() : ImagesIt();
    // const images = ImagesIt();

    const imageClickHandler = useCallback((key: string) => {
        setImgId(key);
        setVisible(true);
        setOverflow(true);
    }, [])

    const toggleVisibleHandler = useCallback(() => {
        setVisible((prev) => !prev);
        setImgId('');
        setOverflow(visible);
    }, [visible])

    return (
        <div className={ cn() }>
            <Title title={ 'Workplan' }/>
            2025 Pole Revolution Workplan - <a href={ pdfUrl } target={ '_blank' }>Download.pdf</a><br/><br/>
            <div className={ cn('content') }>
                { images.keys().map((key: any) => (
                    <div className={ cn('item') } onClick={ () => imageClickHandler(key) }>
                        <img
                            key={ key }
                            src={ images(key) }
                            alt={ key }
                        />
                    </div>
                )) }
                <Modal imgId={ imgId } visible={ visible } images={ images }
                       toggleVisibleHandler={ toggleVisibleHandler }/>
            </div>
        </div>
    );
};
